export const increment = ({commit}) => {
    commit('INCREMENT')
}
export const decrement = ({commit}) => {
    commit('DECREMENT')
}



// WEBPACK FOOTER //
// ./src/components/store/actions.js